import { Component, HostListener } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  innerWidth = 0;
  // @HostListener('window:resize', ['$event'])
  // onResize(event: any) {
  //   this.utilService.isMobile$.next(window.innerWidth < 768);
  // }

  title = 'ΕΚΑΠΥ - Μητρώο Προμηθευτών';
  token$ = this.authService.token$;
  // isMobile$ = this.utilService.isMobile$;
  isStageEnvironment = false;
  isSidebarVisible = false;

  constructor(
    private primengConfig: PrimeNGConfig,
    private translateService: TranslateService,
    private authService: AuthService
  ) {
    this.primengConfig.ripple = true;
    this.authService.hydrate();
    // let token = localStorage.getItem('token');
    // if(token){
    //   let tkn = JSON.parse(token);
    //   if (tkn) this.authService.setToken(tkn);
    // }
  }

  ngOnInit(): void {
    this.translateService.setDefaultLang('el');
    this.translateService.use('el');
    this.translateService
      .get('primeng')
      .subscribe((res: any) => this.primengConfig.setTranslation(res));

    this.token$.subscribe((t) => {
      this.isStageEnvironment =
        (window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
          window.location.href.indexOf('local') !== -1) &&
        t
          ? true
          : false;
      if (!t) return;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
  }
}
